import { apiIsomorphicFetchUserEnvironment } from 'api/userEnvironment/apiFetchUserEnvironment';
import type { LayoutHandleProps } from 'layouts/Layout/LayoutHandleProps';
import { redirectRequireAuthentication } from 'modules/auth/routing/redirect-require-authentication';
import { userDashboardApiHorizonFetchListingApplication } from 'modules/userDashboard/api/listingApplication/userDashboardApiFetchListingApplication';
import { userDashboardApplicationSummaryRoute } from 'modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { ApplicationSummaryPageLoadable } from './ApplicationSummaryPageLoadable';

export const hypernovaClientOnly = true;

export const handle = {
  darkBackground: true,
  fallbackUrlByLocaleToCurrent: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { applicationId },
}: HorizonAppRouteLoaderArgs<typeof userDashboardApplicationSummaryRoute>) {
  const { user } = await apiIsomorphicFetchUserEnvironment({
    request,
    context,
  })();

  if (!user) return redirectRequireAuthentication({ request });

  const [listingApplication] = await Promise.all([
    userDashboardApiHorizonFetchListingApplication({ request, context })(
      applicationId,
    ),
    ApplicationSummaryPageLoadable.load(),
  ]);

  return { listingApplication };
}

export default function UserDashboardApplicationSummaryHorizonRoute({
  loaderData: { listingApplication },
}: HorizonAppRouteComponentProps<typeof loader>) {
  return <ApplicationSummaryPageLoadable application={listingApplication} />;
}
